import orgamax from 'ampersand-app'
import getCurrentVatRate from './getCurrentVatRate'

const buildPositionCategory = (option, date, preserveCurrentRate = false) => {
  const vatList = orgamax.user.getVatList(date)
  const currentRate = getCurrentVatRate(option.allowedVatRates, vatList)
  return {
    bookkeepingAccountId: option.id,
    bookkeepingAccountDescriptionCustom: option.accountDescriptionCustom,
    bookkeepingAccountNo: option.accountNo,
    accountCategory: option.accountCategory,
    // FLAG:useDocuAi (review/compact) — the review path keeps a legitimate 0% current rate
    // (`??`); the legacy path stays byte-identical to f2ac6a682f (`||`, so a 0% current rate
    // still falls back to the account default). preserveCurrentRate is set only by the
    // compact review row.
    vatDefaultRate: preserveCurrentRate
      ? (currentRate ?? option?.allowedVatRates?.default)
      : (currentRate || option?.allowedVatRates?.default),
    vatOption: option.vatOption,
    allowedVatRates: option?.allowedVatRates,
  }
}

export default buildPositionCategory
